import axios from 'axios';
import { getSessionData } from './Util';
import { CallingApp } from '../Constant';

const ENV = process.env.REACT_APP_ENVIRONMENT;

const sanitizeHeaders = (headers = {}) => {
  const sanitizedHeaders = {};

  Object.entries(headers).forEach(([key, value]) => {
    if (value === null || value === undefined) {
      return;
    }

    sanitizedHeaders[key] =
      typeof value === 'string'
        ? value.replace(/[^\x00-\xFF]/g, '')
        : String(value);
  });

  return sanitizedHeaders;
};

export const getHeaders = () => {
  const tokenData = getSessionData('tokenData') || {};

  const {
    caseId,
    companyId,
    userId,
    userName,
    doctorId,
    doctorName,
    providerId,
    providerName,
    doctorSpecialtyId,
    doctorSpecialtyName,
  } = tokenData;

  const userIp =
    sessionStorage.getItem('UserIp') || 'unknown';

  const browserInfo =
    sessionStorage.getItem('Browser') || 'unknown';

  const headers = {
    Env: ENV,
    CallingApp: CallingApp,
    UserInfo: `browser:${browserInfo},ip:${userIp}`,
    UserIp: userIp,

    caseId: caseId || null,
    companyId: companyId || null,

    UserId: userId || null,
    UserName: userName || null,

    DoctorId: doctorId || null,
    DoctorName: doctorName || null,

    ProviderId: providerId || null,
    ProviderName: providerName || null,

    SpecialtyId: doctorSpecialtyId || null,
    SpecialtyName: doctorSpecialtyName || null,
  };

  return sanitizeHeaders(headers);
};

export const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(
  (config) => {
    const headers = {
      ...config.headers,
      ...getHeaders(),
    };

    config.headers = sanitizeHeaders(headers);

    return config;
  },
  (error) => Promise.reject(error)
);

export const fetchInstance = async (url, options = {}) => {
  const headers = {
    'Content-Type': 'application/json',
    ...getHeaders(),
    ...options.headers,
  };

  const config = {
    ...options,
    headers: sanitizeHeaders(headers),
  };

  const response = await fetch(url, config);

  if (!response.ok) {
    throw new Error(`HTTP error: ${response.status}`);
  }

  return response;
};